import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';

/** Score based on the ratings of GW by audited teams */
export default new VitalityCriterion({
  titleTr: 'VH_GW_RATINGS',
  key: 'gwRatings',
  weight: 1,
  score: ({ completedGws }, { start, end }) => {
    // Filter completed GW for the period
    const filtered = completedGws.filter(gw => start.isBefore(gw.date) && end.isAfter(gw.date));
    // Concat all ratings into an array
    const allRatings = filtered.reduce((ratings, gw) => {
      return [...ratings, ...gw.ratings];
    }, []);

    const nRatings = allRatings.length;
    let nTotalMood = 0;
    let nTotalRelevance = 0;
    let nMoodRatings = 0;
    let nRelevanceRatings = 0;
    if (nRatings > 0) {
      for (let i = 0; i < nRatings; i++) {
        const rating = allRatings[i];
        if (rating.ratingMood) {
          nTotalMood += rating.ratingMood;
          nMoodRatings++;
        }
        if (rating.ratingRelevance) {
          nTotalRelevance += rating.ratingRelevance;
          nRelevanceRatings++;
        }
      }
      nTotalMood /= nMoodRatings;
      nTotalRelevance /= nRelevanceRatings;
    }

    const score = (nTotalMood + nTotalRelevance) * 10 / 2;

    return {
      score,
      data: {
        noTopsFlops: nRatings === 0 || nMoodRatings + nRelevanceRatings === 0,
        noCategoryHint: nRatings === 0 || nMoodRatings + nRelevanceRatings === 0,
        value: score,
        nTotalMood,
        nTotalRelevance,
        nRatings,
      },
    };
  },

  text({ nTotalMood, nTotalRelevance, nRatings }) {
    if (nRatings === 0) {
      return i18n.t('message.VH_GW_RATINGS_NONE_TEXT');
    }
    return i18n.t(
      'message.VH_GW_RATINGS_TEXT',
      { mood: nTotalMood.sToFixed(1), relevance: nTotalRelevance.sToFixed(1) },
    );
  },

});
